import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as Logger from "js-logger";
import * as Store from "../../store";

import template from "./devotee.vue";
import Devotee from "../../models/Devotee";
import Product from "../../models/Product";
import { timingSafeEqual } from "crypto";

declare var Razorpay: any;

@Component({
  mixins: [template]
})
export default class DevoteeView extends Vue {
  minimumDonation: number = 0.0;
  progressFlag: boolean = false;
  failedFlag: boolean = false;
  validationFailed: boolean = false;
  orderUuid: string;
  errors: Array<Array<any>>;
  completed: boolean = false;

  get cart(): Array<Product> {
    return Store.readBasket(this.$store);
  }
  get total(): number {
    return this.cart.reduce((total: number, p: Product) => {
      return Number(total) + Number(p.donation);
    }, 0);
  }

  /*
  calculateFees(total: number): number {
    const dharmamMap = new Map();
    let transferTotal = 0;
    this.cart.forEach((item: Product) => {
      if (item.dharmamId != 9) {
        const collection = dharmamMap.get(item.dharmamId);
        if (!collection) {
          dharmamMap.set(item.dharmamId, item.donation + collection);
          transferTotal += item.donation;
        } else {
          collection.push(item.donation);
        }
      }
    });
    // console.log(dharmamMap);
    // console.log(transferTotal);
    let serviceCharge = total * 0.02;
    let gst = serviceCharge * (total <= 2000 ? 0 : 0.18);
    let routeFee = transferTotal * 0.0025 + transferTotal * 0.0025 * 0.18;
    let roundOff =
      (serviceCharge + gst + routeFee) * (total <= 2000 ? 0.021 : 0.0243);
    let fee = serviceCharge + gst + routeFee + roundOff;

    return parseFloat(fee.toFixed(2));
  }
*/

  get totalAfterFees(): number {
    return this.total + this.fees;
  }

  async created() {
    this.minimumDonation = this.cart.reduce((total: number, p: Product) => {
      return Number(total) + Number(p.donation);
    }, 0);
    this.donation = this.minimumDonation;
    await this.calculateFees();
    const dict = {
      custom: {
        mobile: {
          regex:
            "Please provide valid Contact Number to receive SMS, +919500111111"
        },
        name: {
          required: () => "Your name is empty"
        }
      }
    };
    this.$validator.localize("en", dict);
    Logger.debug("Total Donation ", this.donation);
    window.onbeforeunload = () => {
      if (this.completed === false) return "Are you sure you want to leave?";
    };
  }

  handleQuit() {
    console.log("Quitting...");
    const answer = window.confirm(
      "Radhe Krishna! Do you really want to leave? you haven't completed your request. If you have/had any difficulties, plesae let us know by using Contact Us at the top of email sathsang@srisrianna.com. We will resolve it as sson as possible"
    );
  }

  calculateFees() {
    Store.calculateFees(this.$store)
      .then((fees: number) => {
        this.fees = fees;
      })
      .catch(err => {
        this.failed = true;
      });
  }

  get donation(): number {
    return Store.readTotalDonation(this.$store);
  }

  set donation(donation: number) {
    Store.commitTotalDonation(this.$store, donation);
  }

  get fees(): number {
    return Store.readFees(this.$store);
  }

  set fees(donation: number) {
    Store.commitFees(this.$store, donation);
  }

  get notes(): string {
    return Store.readNotes(this.$store);
  }

  set notes(notes: string) {
    Store.commitNotes(this.$store, notes);
  }

  get type(): string {
    return Store.readDevoteeType(this.$store);
  }

  get indianPassportHolder(): boolean {
    return this.type === "" || this.type === "dom";
  }

  set type(type: string) {
    Store.commitDevoteeType(this.$store, type);
  }

  get minmumDonation(): number {
    return this.minimumDonation;
  }

  get progress(): boolean {
    return this.progressFlag;
  }

  set progress(progressFlag: boolean) {
    this.progressFlag = progressFlag;
  }

  get failed(): boolean {
    return this.failedFlag;
  }

  set failed(failedFlag: boolean) {
    this.failedFlag = failedFlag;
  }

  get uuid(): string {
    return this.orderUuid;
  }

  set uuid(uuid: string) {
    this.orderUuid = uuid;
  }

  get devotee(): Devotee {
    return Store.readDevotee(this.$store);
  }

  async switchType(type: string) {
    this.type = type;
    this.progress = true;
    await this.calculateFees();
    this.progress = false;
  }

  doDonate() {
    if (this.type == "intl") {
      window.alert("Radhe Krishna!, Unfortunately we couldn't accept International Donations due to Govt regulations.");
      return;
    }
    // Logger.debug(this.errors["items"].length);
    if (this.donation > 0 && this.errors["items"].length == 0) {
      this.progress = true;
      Logger.debug("Placing Order ", this.devotee);

      Store.placeOrder(this.$store)
        .then((response: any) => {
          this.uuid = response.uuid;
          let self = this;
          let options = {
            key: response.key,
            account_id: response.account_id,
            amount: this.donation, /// The amount is shown in currency subunits. Actual amount is ₹599.
            name: "Radhe Krishna!",
            currency: "INR", // Optional. Same as the Order currency
            description: "Sri Krishna Premi Discourses",
            image: "/audio/static/img/srisri-anna-64x64.png",
            prefill: {
              name: this.devotee.firstName + " " + this.devotee.lastName,
              email: this.devotee.email,
              contact: this.devotee.mobile
            },
            notes: response.notes,
            handler: (response: any) => {
              Logger.debug("Verify ", response);
              this.verifySignature(response);
            },
            modal: {
              ondismiss: function() {
                console.log("Checkout form closed");
                self.progressFlag = false;
              }
            }
          };
          let rzp1 = new Razorpay({ ...options, order_id: response.orderId });
          rzp1.open();
        })
        .catch(error => {
          this.failed = true;
          Logger.error("Couldn't place order ", error);
        });
    } else if (this.errors["items"].length > 0) {
      this.validationFailed = true;
    }
  }

  verifySignature(data: any) {
    data.order_uuid = this.uuid;
    data.email = this.devotee.email;
    data.type = this.type;
    Store.confirmPayment(this.$store, data)
      .then(res => {
        Logger.debug("PAYMENT RESPONSE", res);
        Logger.debug("Routing to Download ", this.uuid);
        this.completed = true;
        this.$router.push({ name: "download", params: { uuid: this.uuid } });
      })
      .catch(err => {
        this.failed = true;
        Logger.error("Couldn't Verify Payment ", err);
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/layouts/devotee/index.ts